// Shared collage images for hero sections across all pages
import techTraining1 from "../assets/gallery/education/tech-training1.jpg";
import techTraining2 from "../assets/gallery/education/tech-training2.jpg";
import techTraining3 from "../assets/gallery/education/tech-training3.jpg";
import techTraining4 from "../assets/gallery/education/tech-training4.jpg";
import techTraining5 from "../assets/gallery/education/tech-training5.png";
import classStudents from "../assets/gallery/education/classstudents.png";
import classPupils from "../assets/gallery/education/classpupils.jpeg";
import scholarship from "../assets/gallery/education/scholarship.jpeg";
import healthOutreach1 from "../assets/gallery/health/health-outreach1.jpeg";
import healthOutreach2 from "../assets/gallery/health/health-outreach2.jpeg";
import healthOutreach3 from "../assets/gallery/health/health-outreach3.png";
import roadConstruction1 from "../assets/gallery/community-projects/road-construction1.jpeg";
import roadConstruction2 from "../assets/gallery/community-projects/road-construction2.jpeg";
import groupEventAsset from "../assets/gallery/events/groupix.png";
import graduationImage1 from "../assets/gallery/events/graduation/image1.jpeg";
import graduationImage2 from "../assets/gallery/events/graduation/image2.jpeg";
import graduationImage3 from "../assets/gallery/events/graduation/image3.jpeg";
import graduationImage4 from "../assets/gallery/events/graduation/image4.jpeg";
import graduationImage5 from "../assets/gallery/events/graduation/image5.jpeg";

const groupEvent = `${groupEventAsset}?v=20260424`;

const collageSets = {
  default: [
    classStudents,
    classPupils,
    techTraining1,
    techTraining2,
    techTraining3,
    techTraining4,
    techTraining5,
    groupEvent,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    roadConstruction1,
    roadConstruction2,
    graduationImage1
  ],
  aboutOverview: [
    groupEvent,
    classStudents,
    classPupils,
    scholarship,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    techTraining5,
    roadConstruction1,
    roadConstruction2,
    graduationImage1,
    graduationImage2
  ],
  ourStory: [
    groupEvent,
    roadConstruction1,
    roadConstruction2,
    scholarship,
    classStudents,
    techTraining5,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    graduationImage3,
    graduationImage4,
    graduationImage5
  ],
  employability: [
    techTraining1,
    techTraining2,
    techTraining3,
    techTraining4,
    techTraining5,
    classStudents,
    classPupils,
    scholarship,
    healthOutreach3,
    graduationImage3,
    graduationImage1,
    graduationImage2
  ],
  mentorship: [
    techTraining3,
    techTraining2,
    classStudents,
    classPupils,
    groupEvent,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    scholarship,
    roadConstruction1,
    graduationImage3,
    graduationImage4,
    graduationImage5
  ],
  newsletters: [
    groupEvent,
    graduationImage4,
    scholarship,
    classStudents,
    classPupils,
    techTraining5,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    roadConstruction1,
    roadConstruction2,
    graduationImage1,
    graduationImage2,
    graduationImage3,
    graduationImage4,
    graduationImage5
  ],
  newsEvents: [
    groupEvent,
    classStudents,
    classPupils,
    techTraining1,
    techTraining2,
    techTraining3,
    techTraining4,
    techTraining5,
    scholarship,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    roadConstruction1,
    roadConstruction2,
    graduationImage1,
    graduationImage2,
    graduationImage3,
    graduationImage4,
    graduationImage5
  ],
  contact: [
    groupEvent,
    classStudents,
    classPupils,
    scholarship,
    techTraining1,
    techTraining2,
    techTraining5,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    roadConstruction1,
    roadConstruction2
  ],
  careers: [
    classStudents,
    classPupils,
    techTraining1,
    techTraining2,
    techTraining3,
    techTraining4,
    techTraining5,
    scholarship,
    healthOutreach1,
    healthOutreach2,
    healthOutreach3,
    roadConstruction1,
    roadConstruction2,
    groupEvent,
    graduationImage1,
    graduationImage2,
    graduationImage3,
    graduationImage4,
    graduationImage5
  ]
};

// Create a collage array that can be reused across all pages
export const getCollageImages = (type = "default") => {
  return collageSets[type] || collageSets.default;
};

